export const CONTACT_TYPE = {
  RECRUIT: '採用',
  INQUIRY: 'その他',
} as const;

export const BUSINESS_TYPE = {
  EMPLOYEE: '社員',
  PART_TIMER: 'アルバイト',
} as const;
